import { helper } from '@ember/component/helper';

import { timeSeriesDate as tsd } from 'rise-ui/utils/time-series-date.js';

export default helper(function timeSeriesDateHelper([ value ]) {
  return tsd(value);
});
